import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

interface AiBioProps {
  isMobile: boolean;
  largeScreen: boolean;
  expand: boolean;
  setShowAiBio: (show: boolean) => void;
}

export const AiBio: React.FC<AiBioProps> = ({
  largeScreen,
  setShowAiBio,
  isMobile,
  expand
}) => {
  const { t } = useTranslation();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      className={`mb-8`}
    >
      <div className="relative flex h-full w-full flex-col items-center justify-center gap-5 overflow-y-auto rounded-lg p-4">
        {!largeScreen && (
          <button
            className="absolute right-2 top-0 text-3xl font-bold text-base-100 hover:text-secondary"
            onClick={() => {
              setShowAiBio(false);
            }}
          >
            &times;
          </button>
        )}
        <div className="flex flex-col items-center justify-center gap-5">
          <h1
            className={`mb-1 text-center text-xl ${isMobile ? "w-[80%]" : "max-w-full"}`}
          >
            {t("AI Bio Heading")}
          </h1>
          <img
            className="h-36 min-h-36 w-36 min-w-36 rounded-full"
            src="/assets/images/Jayda_ai.webp"
            alt="ai_chat_image"
          />
        </div>
        <div className={` ${expand ? "mx-8" : "mx-4"} text-justify`}>
          <p>
            {t("AI Bio Description Par 1")}
            <br />
            {t("AI Bio Description Par 2")}
          </p>
        </div>
      </div>
    </motion.div>
  );
};
